
export const MODULE_LABELS_CUSTOMER = {
    DEMANDS_MODULE: 'My Connectivity',
    INCIDENT: 'My Tickets',
    LIVE_SERVICES:'My Connectivity',
    SERVICE_REQUEST:'My Tickets',
    FINCA_INVOICE:'My Invoices',
    CUSTOMER_USERS:'User Management',
    CUSTOMER_ONBOARDING_REQUEST:'User Management',
    VF_INTERNAL_USERS:'User Management',
    CUSTOMER_ONBOARDING_APPROVAL:'User Management',
  };
  export const MODULE_LABELS_INTERNAL = {
    DEMANDS_MODULE: 'Connectivity',
    INCIDENT: 'Tickets',
    LIVE_SERVICES:'Connectivity',
    SERVICE_REQUEST:'Tickets',
    FINCA_INVOICE:'Invoices',
    CUSTOMER_USERS:'User Management',
    CUSTOMER_ONBOARDING_REQUEST:'User Management',
    VF_INTERNAL_USERS:'User Management',
    CUSTOMER_ONBOARDING_APPROVAL:'User Management',
  };

  export const EVENT_CONSTANTS = {
    demand_raised: 'New Demand Raised',
    comment_added: 'Comment Added',
    status_changed: 'Status Changed',
    onboarding_request_raised: 'Onboarding Request Raised',
    onboarding_request_comment_added: 'Comment Added',
    onboarding_request_status_changed: 'Status Changed',
    service_request_raised:"Service Request Raised",
    incident_raised:"Incident Raised",
    incident_comment_added: 'Incident Comment Added',
    incident_status_changed: 'Incident Status Changed',
    incident_priority_changed: 'Incident Priority Changed',
    incident_email_added:"Incident Email Update",
    service_request_comment_added: 'Service Request Comment Added',
    service_request_status_changed: 'Service Request Status Changed',
    service_request_priority_changed: 'Service Request Priority Changed',
    service_request_email_added:"Service Request Email Update",
    internal_user_permission_changed:"Internal User Permission Changed",
    account_manager_assign_to_customer: 'Account Manager Assign To Customer',
    new_customer_user_added: 'New Customer User Added',
    new_vf_internal_user_added: 'New Vf Internal User Added',
    customer_user_permission_changed: 'Customer User Permission Changed',
    customer_user_enable_disable: 'Customer User Status Updated',
    internal_user_enable_disable: 'Internal User Status Updated',
    customer_fincatadigcode_updated: 'Customer Invoice Code Updated',
    customer_oneitsm_service_name_updated:'Oneitsm Service Updated',
    volte_status_changed:'Status Changed',
    volte_comment_added:'Comment Added',
    onboarding_request_approval_reminder:'Onboarding Request Approval Reminder',
    volte_demand_updated:'VoLTE Demand Updated',
    onboarding_request_escalated:'Onboarding Request Escalated',
    account_inactive_reminder: "Account Inactive Reminder",
    feasibiity_initiated: 'Feasibiity Initiated',
    feasibiity_completed: 'Feasibiity Completed',
    floor_pricing_initiated: 'Floor Pricing Initiated',
    margin_initiated: 'Floor Price Generated',
    quotation_generated: 'Quotation Generated',
    quotation_accepted: 'Quotation Accepted',
    quotation_rejected: 'Quotation Rejected',
    order_form_submitted: 'Order Form Submitted',
    order_form_saved: 'Order Form Saved',
    submit_sign_order: 'Signed Order Form Submitted',
    legal_contract_intiate: 'Legal Contract Initiated',
    provisioning_initiated: 'Provisioning Initiated',
    provisioning_completed: 'Provisioning Completed',
    billing_completed: 'Billing Completed',
    demand_completed: 'Demand Completed',
    demand_closed: 'Demand Closed',
    accept_quotation_reminder: 'Quotation Awaiting Acceptance', 
    accept_orderform_reminder: 'Order Form Awaiting Acceptance',
    not_accept_quotation_reminder: 'Quotation Not Acknowledged By Customer',
    not_accept_orderform_reminder: 'Order Form Not Acknowledged By Customer',
    confirm_service_date_reminder: 'Confirm Service Date Reminder',
    quotation_expired: 'Quotation Expired',
    sign_legal_contract_uploaded:'Signed Legal Contract Uploaded',
    service_start_date_submitted:'Service Start Date Submitted',
    service_start_date_reminder:'Service Start Date Reminder',
    demand_cancelled:'Demand Cancelled',
    demand_golive: 'Demand Go Live',
  }

  export const DETAILS_PAGENAME_CONSTANT = {
    VF_INTERNAL_LIST:"VF INTERNAL LIST",
    CUSTOMER_DETAILS:"CUSTOMER DETAILS",
    CUSTOMER_ONBOARDING_APPROVAL:"CUSTOMER ONBOARDING APPROVAL",
    CUSTOMER_ONBOARDING:"CUSTOMER ONBOARDING REQUEST"
  }

export const mapNotificationRoute = {
  DEMAND_TO_CASH: (detailsId, notificationId) =>
    `/connectivity/demandToCashDetail/${detailsId}/${encodeURIComponent(JSON.stringify({notificationId}))}`,        
  DEMANDS: (detailsId, notificationId) =>
    `/connectivity/demandDetail/${detailsId}/${encodeURIComponent(JSON.stringify({notificationId}))}`,
  INCIDENT: (detailsId, notificationId) =>
    `/incident-management/incidentDetail/${detailsId}/${encodeURIComponent(JSON.stringify({notificationId}))}`,
  SERVICE_REQUEST: (detailsId, notificationId) =>
    `/incident-management/serviceRequestDetail/${detailsId}/${encodeURIComponent(JSON.stringify({notificationId}))}`,
  CUSTOMER_ONBOARDING: (detailsId, notificationId) =>
    `/user-management/OnboardingRequestDetail/${detailsId}/${encodeURIComponent(JSON.stringify({notificationId}))}`,
  CUSTOMER_ONBOARDING_APPROVAL: (detailsId, notificationId) =>
    `/user-management/OnboardingDetail/${detailsId}/${encodeURIComponent(JSON.stringify({notificationId}))}`,
  CUSTOMER_DETAILS: (detailsId, notificationId) =>
    `/user-management/customerdetail/${detailsId}/${encodeURIComponent(JSON.stringify({notificationId}))}`,
  VF_INTERNAL_LIST: (_, notificationId) =>
    `/user-management/vodafoneUsers/${encodeURIComponent(JSON.stringify({notificationId}))}`,
};